(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-background"] && !Shopify.designMode) return;
  try {
    (function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-sec-bg]').forEach(function (bg) {
      if (bg.dataset.sbgReady) return;
      bg.dataset.sbgReady = '1';
      /* Pause animations while the background is out of view (performance). */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { bg.classList.toggle('sec-bg--paused', !e.isIntersecting); });
        }, { rootMargin: '120px' });
        io.observe(bg);
      }
      /* Optional subtle mouse parallax on the animation layer, smoothed with a
         requestAnimationFrame lerp so it eases toward the cursor (no lag/jitter).
         Listen on the section wrapper (not the media layer) so the cursor is
         tracked across the whole section — the content sits above the media as a
         sibling, so events over it never reach the media element. */
      if (bg.hasAttribute('data-mouse') && !reduce) {
        var host = bg.closest('.shopify-section') || bg.offsetParent || bg.parentElement || bg;
        var amount = 22;
        var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
        function frame() {
          cx += (tx - cx) * 0.08;
          cy += (ty - cy) * 0.08;
          bg.style.setProperty('--mx', cx.toFixed(2));
          bg.style.setProperty('--my', cy.toFixed(2));
          if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) { raf = requestAnimationFrame(frame); }
          else { raf = null; }
        }
        function kick() { if (!raf) { raf = requestAnimationFrame(frame); } }
        host.addEventListener('mousemove', function (ev) {
          var r = host.getBoundingClientRect();
          if (!r.width || !r.height) return;
          tx = ((ev.clientX - r.left) / r.width - 0.5) * amount;
          ty = ((ev.clientY - r.top) / r.height - 0.5) * amount;
          kick();
        }, { passive: true });
        host.addEventListener('mouseleave', function () { tx = 0; ty = 0; kick(); });
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
